import { render, staticRenderFns } from "./opnProgress.vue?vue&type=template&id=1960c140&scoped=true&"
import script from "./opnProgress.vue?vue&type=script&lang=js&"
export * from "./opnProgress.vue?vue&type=script&lang=js&"
import style0 from "./opnProgress.vue?vue&type=style&index=0&id=1960c140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960c140",
  null
  
)

/* custom blocks */
import block0 from "./opnProgress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1960c140')) {
      api.createRecord('1960c140', component.options)
    } else {
      api.reload('1960c140', component.options)
    }
    module.hot.accept("./opnProgress.vue?vue&type=template&id=1960c140&scoped=true&", function () {
      api.rerender('1960c140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/opnProgress.vue"
export default component.exports